<!-- login.vue
    Permite el acceso o inicio de sesión (login) a la aplicación. -->
<!-- *:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:= -->

<template>

    <div class="container">
        <div class="login center">
            <ul class="collapsible popout">
                <li>
                    <div class="waves-effect waves-light collapsible-header">
                        <!-- <i class="material-icons">screen_lock_rotation</i> -->
                        <span class="center tooltipped" data-tooltip="Haga click aquí para ingresar su e-mail y clave de acceso" data-position="top">
                            <i class="material-icons">screen_lock_rotation</i>ACCEDER A LA APLICACION.
                        </span>
                    </div>
                    
                    <div class="collapsible-body">                    
                        <div class="row">
                            <div class="input-field col s6">
                                <div class="input-field col s12">
                                    <i class="material-icons prefix">contact_mail</i>
                                    <input type="email" v-model="email">
                                    <label>Correo electrónico ?</label>
                                </div>
                            </div>
                            <div v-if="ocultarClave" class="input-field col s6">
                                <div class="input-field col s11">
                                    <i class="material-icons prefix">vpn_key</i>
                                    <input type="password" v-model="password">
                                    <label>Clave de Acceso ?</label>
                                </div>
                                <div class="input-field col s1">
                                    <a class="btn white" @click="toogleClave"><i class="material-icons">visibility</i></a>                            
                                </div>
                            </div>
                            <div v-else class="input-field col s6">
                                <div class="input-field col s11">
                                    <i class="material-icons prefix">vpn_key</i>
                                    <input type="text" v-model="password">
                                    <label>Clave de Acceso ?</label>
                                </div>
                                <div class="input-field col s1">
                                    <a class="btn white" @click="toogleClave"><i class="material-icons">visibility_off</i></a>
                                </div>
                            </div>
                            
                            <div class="input-field col s12">                            
                                <button title="Aceptar" class="waves-effect waves-light btn-floating darken-5 z-depth-3 green btn" @click="signIn"><i class="material-icons">check</i> </button> 
                            </div>
                            
                            <!-- <button class="waves-effect waves-light green btn" @click="signInMem">Acceder </button> -->
                            <!-- <b>Si usted no tiene una cuenta, puede <router-link to="/registro" active-class="activo" exact>crear una !</router-link> </b> -->
                        </div> <!-- row -->
                        <div class="row">
                            <div class="col s5"></div>
                            <div class="col s2" v-if="mostrarCargador">
                                <div class="sk-fading-circle">
                                    <div class="sk-circle1 sk-circle"></div>
                                    <div class="sk-circle2 sk-circle"></div>
                                    <div class="sk-circle3 sk-circle"></div>
                                    <div class="sk-circle4 sk-circle"></div>
                                    <div class="sk-circle5 sk-circle"></div>
                                    <div class="sk-circle6 sk-circle"></div>
                                    <div class="sk-circle7 sk-circle"></div>
                                    <div class="sk-circle8 sk-circle"></div>
                                    <div class="sk-circle9 sk-circle"></div>
                                    <div class="sk-circle10 sk-circle"></div>
                                    <div class="sk-circle11 sk-circle"></div>
                                    <div class="sk-circle12 sk-circle"></div>
                                </div>
                            </div>                        
                            <div class="col s5"></div>
                        </div>
                    </div> <!-- collapsible-body -->
                </li>
            </ul>
        </div> <!-- login -->
    </div> <!-- container -->
    
</template>

<!-- ============================================================================= 
                                <div class="loader center"></div>
-->
<script>

    import {store} from './../store/store.js'
    import firebase from 'firebase';

    import 'materialize-css/dist/css/materialize.min.css'
    import M from 'materialize-css'

    /* :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */    
    export default {

        name: 'login',
        data: function(){
            return { 
                email: null, password: null,
                ocultarClave: true, mostrarCargador: false,
            }
        },
        mounted(){

            var elems = document.querySelectorAll('.collapsible');
            var instances = M.Collapsible.init(elems, {});                
        },        
        methods:{
            toogleClave(){
                this.ocultarClave= ! this.ocultarClave;
            },
            signInMem(){

                // console.log("Estoy en sigInMem !");
                store.state.st_logeado  = true;
                store.state.st_activo   = true;
                store.state.st_roles   = {};
                store.state.st_roles.encuesta= true;
                store.state.st_admin=   true;

                const self =    this;           // SELF es para usarlo dentro de las promesas en lugar de THIS                
                self.$router.push('/');         // Direcciona el ruteo al HOME.                
            },
            signIn(){

                const self =    this;           // SELF es para usarlo dentro de las promesas en lugar de THIS
                var elUID=      "";             // Preserva la llave del usuario autenticado.
                self.mostrarCargador = true;

                /* Verifica si el usuario y clave existen en Firebase */
                firebase.auth().signInWithEmailAndPassword(this.email, this.password)
                .then(function (user) {

                    self.mostrarCargador= false;
                    elUID       = user.user.uid;    // Otiene el UID del usuario autenticado
                    self.bdReadUsuarios(elUID);     // Lee el nodo del usuario para obtener su nombre completo.
                    self.$router.push('/');         // Direcciona el ruteo al HOME.
                })
                .then(function () {

                    self.laUID  = elUID;    // Obtiene la UID preservada.

                    /* Asigna en las variables globales (las definidas en el store) los valores para: 
                        i) saber si está logeado o no el usuario; ii) la UID del usuario, su email y 
                        su password. */
                    store.state.st_logeado = true;             
                    store.state.st_usuario = self.laUID;
                }) 
                .catch(function(error) {

                    /* Obtiene el número y mensaje de error cuando la autenticación es incorrecta */
                    var errorCode = error.code;
                    var errorMessage = error.message;

                    var miMensaje = "NO ERROR";     // Asume que no hay mensaje de error.

                    if (errorCode === "auth/user-not-found"){
                        miMensaje = "Email Invalido. Cuenta NO existe !"
                    } else {
                        if (errorCode === "auth/wrong-password"){
                            miMensaje = "Password Invalido. El password NO existe o No escribió Password !"
                        } else {
                            if (errorCode === "auth/invalid-email") {
                                miMensaje= "Email Invalido. La cuenta de email tiene un formato NO válido."
                            } else{
                                if (errorCode === "auth/operation-not-allowed"){
                                    miMensaje= "El proveedor de inicio de sesión dado está deshabilitado para este proyecto de Firebase.\n"+
                                                "Habilítelo en la consola de Firebase, debajo del inicio de sesión: "+
                                                "pestaña de método de la sección de autenticación.";
                                } // if
                            } // else
                        } // else
                    } // else

                    /* Si Encontró algún error lo muestra !*/
                    if (miMensaje != "NO ERROR"){
                        alert(miMensaje);
                    }
                }); // catch()
            }, // signIn()
            getUsuarios(losUsuarios,laLlave){

                /* Recorro la info original del nodo para encontrar el nombre del usuario */
                /* Prepara el objeto de memoria para obtener la lista de usuarios */
                // store.state.usuarios= [];
                for (let key in losUsuarios){

                    // console.log("key ? ",key);
                    /* Si la ID del usuario en sesión fue encontrada, entonces obtiene el nombre del usuario, 
                       los roles que tiene asignados y si está o no activo */
                    if (losUsuarios[key].laid === laLlave){

                        store.state.st_nusuario= losUsuarios[key].nombre;
                        store.state.st_roles=    losUsuarios[key].roles;
                        store.state.st_activo=   losUsuarios[key].activo;
                        store.state.st_admin=    losUsuarios[key].administrador;
                        store.state.st_email=    losUsuarios[key].email;
                        store.state.st_clave=    losUsuarios[key].clave;
                        store.state.st_empresa=  losUsuarios[key].empresa;
                        store.state.st_llave=    key;
                    }; // if()
                } // for                
            }, // getUsuarios
            bdReadUsuarios(laLlave){

                var dummy= store.state.st_dbUsuarios
                            .on( 'value',snapshot=> this.getUsuarios( snapshot.val(), laLlave ) );
            }, // bdReadUsuarios
        }, // methods
    } // export

</script>


// WEBPACK FOOTER //
// src/components/login.vue